import React, {useEffect, useState, useContext} from "react";
import {auth} from "../../configs/firebase-config";
import {useHistory} from "react-router";
import {onAuthStateChanged} from "firebase/auth";
import {checkUserDoc, checkSubscription, displayToast, toastType} from "../../global/Functions";
import {AuthContext} from "../../global/AuthContext";
import ButtonPrimary from "../../components/Button/ButtonPrimary";
import BgGlassmorphism from "../../components/BgGlassmorphism/BgGlassmorphism";


const PageVerification = () => {
  const history = useHistory();
  const [user, setUser] = useState<any>();


  const {setIsVerified} = useContext(AuthContext);

  useEffect(() => {
    const authStateChanged = onAuthStateChanged(auth, (user) => {
      setUser(user);
    })

    return () => {
      authStateChanged();
    }
  }, [])


  const verifyUser = async () => {
    if (!user) return;
    await user.reload();
    if (user.emailVerified) {
      displayToast("Successfully Verified", toastType.success)
      setIsVerified(true);
      await checkUserDoc(user);
      const exists = await checkSubscription(user.uid);
      exists ? history.push("/dashboard") : history.push("/subscription")
    } else {
      displayToast("Check your emails", toastType.info)
    }
  }

  return(
      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <BgGlassmorphism/>
      <div
          className={`text-center justify-center SectionMarkets relative flex flex-col lg:flex-row items-center`}
          data-id="SectionMarkets"
      >
        <div className="text-center justify-center flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
          <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
            Please verify your email
          </h2>
          <span className="justify-center block mt-8 text-neutral-500 dark:text-neutral-400">

            Almost there! We sent a verification email to<br/><br/> <strong>{auth.currentUser?.email}</strong>{" "} <br/><br/>
            Just tap the link in that email to verify your account.
            Then head back here to get started.
            If you don't see it, you may need to check your spam folder.
        </span>
          <div className="flex space-x-4 mt-1 justify-center py-10">
            <ButtonPrimary onClick={verifyUser}>Verify Account
            </ButtonPrimary>
          </div>

        </div>
      </div>
      </div>
  )
}

export default PageVerification;
